import { USER_REQUEST, USER_ERROR, USER_SUCCESS, GET_USERS, GET_ROLE, ROLE_SUCCESS, USERS_SUCCESS} from '../actions/user'
import apiCall from '../../components/Login/api'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'
import _ from "lodash";
const state = { status: '', profile: {}, users:[] ,role: ''}

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  getUsers: state => state.users,
  getRole: state => state.role
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    console.log('get user')
    commit(USER_REQUEST)
    const token = localStorage.getItem('vuex')
    const parsed = JSON.parse(token)
    const userid = parsed['auth']['id']
    const role = parsed['auth']['role']
    console.log('userid', userid)
    apiCall.getLoggedInUserProfile(role, userid)
      .then(resp => {
        console.log('profile', resp.data)
        commit(USER_SUCCESS, resp.data)
        dispatch(GET_ROLE)
      })
      .catch(resp => {
        commit(USER_ERROR)
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT)
      })
  },
  [GET_USERS]: ({commit, dispatch}) => {
    commit(GET_USERS)
    console.log('get users')
    apiCall.getAdminUsers()
      .then(resp => {
        const users =resp.data
        commit(USERS_SUCCESS, users)
      })
      .catch(resp => {
        commit(USER_ERROR)
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT)
      })
  },
  [GET_ROLE]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
    commit(GET_ROLE)
    console.log('get role')
        const token = localStorage.getItem('vuex')
        const parsed = JSON.parse(token)
        const role = parsed['auth']['role']
        console.log('Role is ',role)
        commit(ROLE_SUCCESS,role)
        resolve(role);

    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [GET_USERS]: (state) => {
    state.status = 'loading'
  },
  [GET_ROLE]: (state) => {
    state.status = 'loading'

  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [ROLE_SUCCESS]: (state, resp) => {
    state.status = 'success'
    console.log('roll esuccess')
console.log(resp)
    Vue.set(state, 'role', resp)

   //fake a role
  //  Vue.set(state, 'role', 'tutor')

  },
  [USERS_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'users', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js